function exec(command, value = null) {
    document.execCommand(command, false, value);
}

function closestEditor(root) {
    return root?.querySelector?.('[data-rich-editor-surface], [data-mail-editor-surface]') ?? null;
}

function syncEditor(root) {
    const editor = closestEditor(root);
    const input = root.querySelector('[data-rich-editor-input], [data-mail-editor-input]');
    const source = root.querySelector('[data-rich-editor-source], [data-mail-editor-source]');
    if (!editor || !input) return;
    input.value = editor.innerHTML.trim();
    if (source && !source.dataset.editingSource) {
        source.value = input.value;
    }
}

function insertHtml(html) {
    exec('insertHTML', html);
}

function handleCommand(root, button) {
    const command = button.dataset.editorCommand || button.dataset.mailCommand;
    const editor = closestEditor(root);
    if (!command || !editor) return;
    editor.focus();

    if (command === 'formatBlock') {
        exec('formatBlock', button.dataset.editorValue || button.dataset.value || 'p');
        return;
    }
    if (command === 'createLink') {
        const url = window.prompt('URL odkazu (https://…):', 'https://');
        if (url) exec('createLink', url.trim());
        return;
    }
    if (command === 'insertImage') {
        const url = window.prompt('URL obrázku (musí být veřejně dostupná přes https://):', 'https://');
        if (!url) return;
        const alt = window.prompt('Alternativní text obrázku:', '') || '';
        insertHtml(`<p><img src="${escapeAttr(url.trim())}" alt="${escapeAttr(alt)}"></p>`);
        return;
    }
    if (command === 'insertButton') {
        const label = window.prompt('Text tlačítka:', 'Otevřít Clasico.cz');
        if (!label) return;
        const url = window.prompt('URL tlačítka:', '{{clasico_url}}');
        if (!url) return;
        const style = button.dataset.editorValue || button.dataset.value || 'primary';
        insertHtml(`<p><a href="${escapeAttr(url.trim())}" data-mail-button="${escapeAttr(style)}">${escapeHtml(label.trim())}</a></p>`);
        return;
    }
    if (command === 'insertHorizontalRule') {
        insertHtml('<hr>');
        return;
    }
    if (command === 'blockquote') {
        exec('formatBlock', 'blockquote');
        return;
    }

    exec(command, button.dataset.editorValue || button.dataset.value || null);
}

function escapeAttr(value) {
    return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('"', '&quot;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
}

function escapeHtml(value) {
    return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
}

function syncCounter(root, editor) {
    const counter = root.querySelector('[data-rich-editor-counter]');
    if (!counter || !editor) return;

    const max = Number.parseInt(root.dataset.richEditorMaxLength || '0', 10);
    const length = String(editor.innerText || editor.textContent || '')
        .replace(/\u00a0/g, ' ')
        .trim().length;

    counter.textContent = max > 0 ? `${length} / ${max}` : String(length);
    counter.classList.toggle('text-red-500', max > 0 && length > max);
}

function initOne(root) {
    if (root.dataset.mailEditorReady === '1') return;
    root.dataset.mailEditorReady = '1';

    const editor = closestEditor(root);
    const input = root.querySelector('[data-rich-editor-input], [data-mail-editor-input]');
    const source = root.querySelector('[data-rich-editor-source], [data-mail-editor-source]');
    const sourceToggle = root.querySelector('[data-rich-editor-source-toggle], [data-mail-source-toggle]');
    if (!editor || !input) return;

    editor.innerHTML = input.value || '<p></p>';
    if (source) source.value = input.value || '';
    syncCounter(root, editor);

    root.addEventListener('click', (event) => {
        const commandButton = event.target.closest('[data-editor-command], [data-mail-command]');
        if (commandButton && root.contains(commandButton)) {
            event.preventDefault();
            handleCommand(root, commandButton);
            syncEditor(root);
            syncCounter(root, editor);
            return;
        }

        const variableButton = event.target.closest('[data-mail-variable]');
        if (variableButton && root.contains(variableButton)) {
            event.preventDefault();
            editor.focus();
            insertHtml(escapeHtml(variableButton.dataset.mailVariable || ''));
            syncEditor(root);
            syncCounter(root, editor);
        }
    });

    editor.addEventListener('input', () => {
        syncEditor(root);
        syncCounter(root, editor);
    });
    editor.addEventListener('blur', () => {
        syncEditor(root);
        syncCounter(root, editor);
    });

    sourceToggle?.addEventListener('click', () => {
        const sourceWrap = root.querySelector('[data-rich-editor-source-wrap], [data-mail-source-wrap]');
        if (!sourceWrap || !source) return;

        const opening = sourceWrap.classList.contains('hidden');
        if (opening) {
            syncEditor(root);
            source.value = input.value;
            source.dataset.editingSource = '1';
            sourceWrap.classList.remove('hidden');
            editor.classList.add('hidden');
            sourceToggle.dataset.active = '1';
            source.focus();
        } else {
            source.dataset.editingSource = '';
            editor.innerHTML = source.value;
            sourceWrap.classList.add('hidden');
            editor.classList.remove('hidden');
            sourceToggle.dataset.active = '';
            syncEditor(root);
            editor.focus();
        }
    });

    source?.addEventListener('input', () => {
        if (source.dataset.editingSource === '1') {
            input.value = source.value;
        }
    });

    const form = root.closest('form');
    form?.addEventListener('submit', () => {
        if (source?.dataset.editingSource === '1') {
            editor.innerHTML = source.value;
        }
        syncEditor(root);
    });
}

export function initMailEditors(context = document) {
    context.querySelectorAll('[data-mail-editor], [data-rich-editor]').forEach(initOne);
}
